module.exports = __webpack_public_path__ + "img/category_14.ecf5a9a6.png";